'use client';
import React, { FC } from 'react';

import TourDetailProvider from '@components/views/tour/detail/context';
import TourDetail from '@components/views/tour/detail/TourDetail';
import { SearchURLProvider } from '@api/data-loaders/resource';
import { SearchViewModel, TourDetailViewModel, TourType } from '@api/index';

import { PageContainer } from './styled';

export interface ITourDetailProps {
  resourceType?: string;
  initialTourSSRData: TourDetailViewModel | null;
  urlSearch?: SearchViewModel;
  is404?: boolean;
}

const TourDetailScreen: FC<ITourDetailProps> = ({
  initialTourSSRData,
  urlSearch,
}) => {
  const resource =
    initialTourSSRData?.type === TourType.CRUISE ? 'Gemi' : 'Tur';
  return (
    <SearchURLProvider value={urlSearch}>
      <PageContainer>
        <TourDetailProvider resource={resource}>
          <TourDetail initialTourSSRData={initialTourSSRData} />
        </TourDetailProvider>
      </PageContainer>
    </SearchURLProvider>
  );
};

export default TourDetailScreen;
